export const testimonials = [
  {
    id: 0,
    name: "KENZIE EDGAR",
    img: "https://i.pravatar.cc/100?img=1",
    star:5,
    content:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos sunt ratione dolor exercitationem minima quas itaque saepe quasi architecto vel! Accusantium, vero sint recusandae cum tempora nemo commodi soluta deleniti.",
  },
  {
    id: 1,
    name: "TOMMIE EWART",
    img: "https://i.pravatar.cc/100?img=3",
    star:5,
    content:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Vitae, obcaecati ullam excepturi dicta error deleniti sequi.",
  },
  {
    id: 2,
    name: "NEVADA HERBERTSON.",
    img: "https://i.pravatar.cc/100?img=3",
    star:4,
    content:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis, voluptatem porro obcaecati dicta, quibusdam sunt ipsum, laboriosam nostrum facere exercitationem pariatur deserunt tempora molestiae assumenda nesciunt alias eius? Illo, autem",
  },
  {
    id: 3,
    name: "STEVIE TIFFTR",
    img: "https://i.pravatar.cc/100?img=2",
    star:5,
    content:
"Lorem ipsum, dolor sit amet, consectetur adipisicing elit. Dolore quod necessitatibus, labore sapiente, est, dignissimos ullam error ipsam sint quam tempora vel"  },
  {
    id: 4,
    name: "CHARLIE HOWSE. ",
    img: "https://i.pravatar.cc/100?img=4",
    star:5,
    content:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto inventore voluptatum nostrum atque, corrupti, vitae esse id accusamus dignissimos neque reprehenderit natus, hic sequi itaque dicta nisi voluptatem! Culpa, iusto",
  },
  {
    id: 5,
    name: "KRIS STANTON.    ",
    img: "https://i.pravatar.cc/100?img=6",
    star:5,
    content:
"Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem iusto, explicabo, cupiditate quas totam!"  },
];
